<!--
 * @Author: amywulan
 * @Date: 2020-09-07 11:03:06
 * @LastEditors: amywulan
 * @LastEditTime: 2020-09-07 11:04:00
 * @Description: 
-->
<template>
  <div class="inpterrupt" @transitionend="expandEnd" :style="{height: `${height}px`}">
    <div class="opacity-wrap" ref="opacity">
      <slot name="content">
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 插入进来数据高度
    height: {
      type: Number,
      default: 0
    }
  },
  methods: {
    expandEnd () {
      this.$refs.opacity.style.opacity = 1
    }
  }
}
</script>

<style lang="stylus" scoped>
.inpterrupt {
  width 100%
  transition height .3s ease-out
  overflow hidden
  .opacity-wrap {
    opacity 0
    transition opacity .2s linear
  }
}
</style>